import React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { SYLLABUS } from './data';

// Radix Dialog gives focus trap, Escape-to-close, focus return and background scroll lock.
export const SyllabusModal = ({ open, onOpenChange, returnFocusRef }) => (
  <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-[#111]/70" />
      <DialogPrimitive.Content aria-describedby="cv-syllabus-desc"
        onCloseAutoFocus={(e) => { e.preventDefault(); returnFocusRef?.current?.focus(); }}
        className="fixed z-50 inset-x-3 top-[4vh] bottom-[4vh] sm:inset-x-auto sm:left-1/2 sm:-translate-x-1/2 sm:w-[720px] flex flex-col bg-[#F5F3EB] text-[#111] border-4 border-[#111] shadow-[10px_10px_0_#D7FF38] focus:outline-none"
        style={{ fontFamily: "'JetBrains Mono', monospace" }} data-testid="syllabus-modal">
        <div className="flex items-start justify-between gap-4 p-5 sm:p-7 border-b-2 border-[#111] bg-[#111] text-[#F5F3EB]">
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#D7FF38]">Workshop syllabus · 180 minutes</p>
            <DialogPrimitive.Title className="cv-display text-2xl sm:text-4xl font-extrabold uppercase mt-2" style={{ fontFamily: "'Syne', sans-serif" }}>AI &amp; Agentic AI</DialogPrimitive.Title>
            <DialogPrimitive.Description id="cv-syllabus-desc" className="text-xs mt-2 text-[#F5F3EB]/75">16 November 2026 · 9:30 AM – 12:30 PM · Proposed outline, subject to change.</DialogPrimitive.Description>
          </div>
          <DialogPrimitive.Close className="shrink-0 w-11 h-11 bg-[#D7FF38] text-[#111] border-2 border-[#F5F3EB] flex items-center justify-center hover:bg-white transition-colors" aria-label="Close syllabus" data-testid="syllabus-close-btn">
            <X size={20} />
          </DialogPrimitive.Close>
        </div>
        <ol className="flex-1 overflow-y-auto overscroll-contain p-5 sm:p-7 space-y-4" data-testid="syllabus-modules">
          {SYLLABUS.map((m) => (
            <li key={m.n} className="bg-white border-2 border-[#111] shadow-[4px_4px_0_#111]" data-testid={`syllabus-module-${m.n}`}>
              <div className="flex items-center justify-between gap-3 border-b-2 border-[#111] px-4 py-3">
                <h3 className="font-extrabold uppercase text-sm sm:text-base"><span className="text-[#365CFF]">Module {m.n}</span> — {m.title}</h3>
                <span className="shrink-0 bg-[#D7FF38] border-2 border-[#111] px-2 py-0.5 text-[11px] font-extrabold">{m.mins} MIN</span>
              </div>
              <ul className="px-4 py-3 space-y-1.5">
                {m.points.map((p) => <li key={p} className="flex gap-2 text-sm"><span className="font-extrabold">›</span>{p}</li>)}
              </ul>
            </li>
          ))}
          <li className="flex items-center justify-between bg-[#111] text-[#F5F3EB] px-4 py-3 font-extrabold uppercase text-sm" data-testid="syllabus-total">
            <span>Total</span><span className="text-[#D7FF38]">180 minutes</span>
          </li>
          <li className="text-[11px] text-[#111]/70 list-none">This is a proposed outline. Specific tools, platforms, and production deployment are not guaranteed.</li>
        </ol>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  </DialogPrimitive.Root>
);
